import { createAsyncThunk } from '@reduxjs/toolkit';
import { generateUUID, getCatalog } from '@qodly/shared';

export const fetchCatalog = createAsyncThunk<
  datasources.IEnhancedCatalog,
  void,
  {
    rejectValue: string;
  }
>('catalog/fetchCatalog', async (_, { rejectWithValue }) => {
  try {
    const catalog = await getCatalog();
    const dataClassByCollectionName = new Map<
      string,
      datasources.IDetailedDataClass
    >();
    const dataClasses = new Map<string, datasources.IDetailedDataClass>();

    const singletons = new Map<string, datasources.ISingletonClass>();

    catalog.singletons?.forEach(({ methods = [], ...signleton }) => {
      const sngltn = { ...signleton, methods };

      singletons.set(signleton.name, sngltn);
    });

    catalog?.dataClasses?.forEach(({ methods = [], ...dataclass }) => {
      if (!dataclass.uuid) {
        Object.assign(dataclass, { uuid: generateUUID() });
      }

      if (dataclass.attributes) {
        const kindToKeep = ['storage', 'relatedEntity'];

        dataclass.attributes = dataclass.attributes.map((attribute) => {
          if (kindToKeep.includes(attribute.kind) && !attribute.uuid) {
            Object.assign(attribute, { uuid: generateUUID() });
          }

          return attribute;
        });
      }

      const dc = { ...dataclass, methods };
      dataClasses.set(dataclass.className, dc);
      dataClassByCollectionName.set(dataclass.collectionName, dc);
    });

    return {
      __BASEID: catalog.__BASEID,
      __UNIQID: catalog.__UNIQID,
      dataClassByCollectionName: Object.fromEntries(
        dataClassByCollectionName.entries(),
      ),
      methods: catalog.methods || [],
      dataClasses: Object.fromEntries(dataClasses.entries()),
      singletons: Object.fromEntries(singletons.entries()),
    };
  } catch (e) {
    return rejectWithValue('Error while loading the catalog');
  }
});
